export enum TransactionStatus {
  PENDING = 'PENDING',
  FINALIZED = 'FINALIZED',
  VOIDED = 'VOIDED',
  REVERSED = 'REVERSED',
  PARTIALLY_REVERSED = 'PARTIALLY_REVERSED',
}
